import React from "react"
import MultiSelectionCombobox, {MultiSelectionComboboxOption} from "../MultiSelectionCombobox/MultiSelectionCombobox"
import {BusinessVertical as BusinessVerticalEnum} from "../../resources/application"

interface Props {
	name: string
	label: string
	value: string[]
	setFieldValue: Function
	setFieldTouched: Function
	hideClearAllIndicator?: boolean
}

export default function BusinessVerticalsField({
	name,
	label,
	value,
	setFieldValue,
	setFieldTouched,
	hideClearAllIndicator,
}: Props) {
	const entries = Object.entries(BusinessVerticalEnum)

	return (
		<div className="countries-field">
			<MultiSelectionCombobox
				name={name}
				label={label}
				value={value}
				options={entries.map(([key, val]) => ({
					value: key,
					label: val,
				}))}
				setFieldValue={(selectedOptions: MultiSelectionComboboxOption[]) => {
					setFieldValue(
						name,
						selectedOptions.map((option) => option.value)
					)
					setFieldTouched(name, true, false)
				}}
				hideClearAllIndicator={hideClearAllIndicator}
			/>
		</div>
	)
}
